import React from 'react';

import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, LastNavItem, NavLinks, ColorNavLinks } from './NavbarElements';
import logo from "../../assets/images/logo.svg"
import menuburger from "../../assets/images/menu-burger.svg"

import "../../assets/css/navbar.css"

const Navbar = ({ toggle }) => {
    return (
        <>
            <Nav>
                <NavbarContainer>
                    <NavLogo className="logo" to="/">
                        <img src={logo} alt="MyPipe logo" />
                        <div className="logo-text">
                            <h1 className="logo-text_big">MyPipe</h1>
                            <h5 className="logo-text_small">Beta</h5>
                        </div>
                    </NavLogo>
                    <MobileIcon onClick={toggle} className='mobile-icon'>
                        <img src={menuburger} alt="menu-burger" />
                    </MobileIcon>
                    <NavMenu>
                        <NavItem>
                            <NavLinks to="/">FAQ</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks to="/">Premium</NavLinks>
                        </NavItem>
                        <NavItem>
                            <NavLinks onClick={() => { window.scroll(0, 0) }} to="/landingpage">Landing Page</NavLinks>
                        </NavItem>
                        <LastNavItem>
                            <ColorNavLinks to="/">Join Private Beta</ColorNavLinks>
                        </LastNavItem>
                    </NavMenu>
                </NavbarContainer>
            </Nav>
        </>
    )
}

export default Navbar;